<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('admin-episode', true)">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">New Playlist</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <div class="mb-4">
          <p class="input-title text-black">Title</p>
          <base-input
            alternative
            class="mb-3"
            name="Title"
            :rules="{ required: true }"
            placeholder="Title"
            v-model="title"
            maxlength="200"
          >
          </base-input>
        </div>

        <div class="mb-4">
          <p class="input-title text-black">Video URL (Add an embedded link)</p>
          <base-input
            alternative
            class="mb-3"
            name="Video URL"
            :rules="{
              required: true,
              regex:
                /\b((?:https?|http):\/\/)?(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)\b/,
            }"
            placeholder="ex: https://www.youtube.com"
            v-model="video_url"
          >
          </base-input>
        </div>
        <div>
          <p class="input-title text-black">Description</p>
          <base-input
            alternative
            class="mb-3"
            name="Description"
            :rules="{ required: true }"
            placeholder="Description"
            v-model="description"
            maxlength="1000"
          >
          </base-input>
        </div>
        <base-button
          type="primary"
          outline
          class="w-full my-2 py-1"
          native-type="submit"
          >Create</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "./components/FileUploader.vue";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import _ from "lodash";
import { mapState } from "vuex";

export default {
  components: {
    FileUploader,
    quillEditor,
  },
  data() {
    return {
      title: "",
      video_url: "",
      description: "",
      editorOption: {
        theme: "snow",
      },
    };
  },
  computed: {
    ...mapState("playlist", { getAllCategory: "getAllCategory" }),
  },
  methods: {
    async onSubmit() {
      let payload = {
        video_url: this.video_url,
        title: this.title,
        description: this.description,
        playlistId: this.$route.query.pid,
        categoryId: this.$route.query.cid,
      };
      let loader = this.$loading();

      try {
        const blogdata = await this.$store.dispatch(
          "playlist/add_episode",
          payload
        );
        // if (blogdata.code == 200) {
        this.$router.push({
          name: "admin-episode",
          query: {
            pid: this.$route.query.pid,
            cid: this.$route.query.cid,
          },
        });
        this.$swal.fire({
          title: "Congratulations!",
          text: "Your episode has been successfully added to the playlist",
          icon: "success",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        // }
        loader.close();
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },
    handleClick(name, query = false) {
      if (query) {
        this.$router.push({
          name: name,
          query: {
            pid: this.$route.query.pid,
            cid: this.$route.query.cid,
          },
        });
      } else {
        this.$router.push({ name: name });
      }
    },
  },
  mounted() {},
};
</script>
